//
//
//
//
//
//
//
//

import LayoutBase from '~/components/public/layout/base';
import { GetKeySrv } from '~/api/ad';
import { loadStylesheet } from '@/utils/dom';

export default {
  components: {
    LayoutBase,
  },
  computed: {
    isChatroom() {
      return (
        this.$route.path.includes('/chatroom') ||
        this.$route.path.includes('/chiefChatroom')
      );
    },
  },
  async beforeMount() {
    const data = await this.$axios(GetKeySrv('rip'));
    if (data?.result === '1') {
      loadStylesheet('https://cdn.gelonghui.com/static/css/guru_rip.css');
    }
  },
};
